<template>
    <div class="wxAllProperty">
        <div class="propertyContent">
            <div style="margin-left: 10px;">同类别全部资产：</div>
            <ul>
                <li v-for="item in dataList" class="per_li">
                    <div>
                        <div class="head">
                            <h3 style="display: inline-block;">{{item.name}}</h3>
                            <a  @click="toRoute(item.id)">详情</a>
                        </div>
                        <p>规格型号：{{item.model}}</p>
                        <p>所属部门：{{item.department}}</p>
                    </div>
                </li>
                <!--<li class="per_li">-->
                    <!--<div>-->
                        <!--<div class="head">-->
                            <!--<h3 style="display: inline-block;">戴尔电脑笔记本</h3>-->
                            <!--<a href='http://localhost:8080/#/data/wxProperty/wx74e956ad560530e8'>详情</a>-->
                        <!--</div>-->
                        <!--<p>规格型号：12345666</p>-->
                        <!--<p>所属部门：水情科</p>-->
                    <!--</div>-->
                <!--</li>-->
                <!--<li class="per_li">-->
                    <!--<div>-->
                        <!--<div class="head">-->
                            <!--<h3 style="display: inline-block;">苹果电脑笔记本</h3>-->
                            <!--<a href='http://localhost:8080/#/data/wxProperty/wx74e956ad560530e8'>详情</a>-->
                        <!--</div>-->
                        <!--<p>规格型号：12345666</p>-->
                        <!--<p>所属部门：水情科</p>-->
                    <!--</div>-->
                <!--</li>-->
            </ul>

        </div>

    </div>
</template>


<script>
    import wxNav from "../wxNav"
    export default {
        props: ["wxCode","class_type"],
        data () {
          return{
                name:"",
                model:"",
                department:"",
                dataList:[],


            }
        },
        components:{
            wxNav
        },
        methods:{
            loadData:function () {
                var that = this;
                var params = {};
                params.data = {
                    searchValue:{
                      class_code:this.class_type
                    }


                };
                params.token = "swgykj9527";
                console.log(params.data);
                params.url = '/sys/assetlist/list';
                params.success = function(res) {
                    that.$Loading.finish();
//                    alert(JSON.stringify(res))
                    console.log(res);
                    that.dataList=res.data.result.result
//                    that.dataSourceList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPostWX(params);
            },
            toRoute:function (id) {
//                alert('/data/wxProperty/'+window.localStorage.getItem("wxCode")+'/'+id)
                this.$router.push('/data/wxProperty/'+window.localStorage.getItem("wxCode")+'/'+id);
            }
        },
        watch:{

        },
        mounted: function() {
            this.loadData()
        }
    }
</script>

<style lang="scss">
    .wxAllProperty{
        background-color: #efefef;
        height: 100%;
        max-width: 768px;
        padding-top: 10px;
        margin: 0 auto;
        /*text-align: center;*/
        .per_li{
            background-color: #fff;
            border-radius: 5px;
            font-size: 16px;
            width: 95%;
            padding: 5px;
            margin: 10px auto;
            .head{
                position: relative;
                h3{
                    font-weight: bold;
                }
                a{
                    position: absolute;
                    right: 5px;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/propertyMana/wxAllProperty.vue